import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fillChrisStartingEleven } from '../../../../../redux/actions/Team';
import { getCurrentStrategy, isFormationLoading } from '../../../../../redux/selector/Team';
import { isPremiumUser } from '../../../../../redux/selector/User';
import { showPopupWindow } from '../../../../../redux/actions/Popups';
import { POPUPS, STRATEGY_NAMES } from '../../../../../service/constants';
import { StyledChrisWandButton, StyledChrisWandIcon } from './SelectFormation/styled';
export default function ChrisWand() {
  const dispatch=useDispatch();
  const formation=useSelector(getCurrentStrategy);
  const busy=useSelector(isFormationLoading);
  const premium=useSelector(isPremiumUser);
  return <StyledChrisWandButton  type="button" aria-label="Let Chris pick the starting 11" title="Let Chris pick and save your starting 11. Keeps your Delegate setting." disabled={busy} onClick={()=>{
    if (!premium) dispatch(showPopupWindow(POPUPS.MOBILE_REQUIRED_POPUP,POPUPS.MOBILE_REQUIRED_POPUP));
    else if (STRATEGY_NAMES[formation]!=null) dispatch(fillChrisStartingEleven(STRATEGY_NAMES[formation]));
  }}><StyledChrisWandIcon /></StyledChrisWandButton>;
}
